





















































































import {Component, Watch, Vue} from 'vue-property-decorator';
import {Route} from 'vue-router';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CConfirmDialog from '@/components/base/dialog/CConfirmDialog.vue';

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
@Component({
    components: {CConfirmDialog, CNumberField, CSimpleTable},
})
export default class ScheduleEquipmentActivity extends Vue {
    private data: any = null;
    private initialData: any = null;
    private loading: boolean = false;
    private date: Date = new Date(Date.now());
    private items: any = null;
    private datePicker: boolean = false;
    private editing: boolean = false;
    private serverItems: any[] = [];
    private unsavedItems: any[] = [];

    get year() {
        return this.date.getFullYear();
    }

    get month() {
        return this.date.getMonth() + 1;
    }

    get datePickerValue() {
        return this.date.toISOString().substr(0, 10);
    }
    set datePickerValue(value: string) {
        this.date = new Date(value);
    }

    get datePickerBtnText() {
        const month = this.date.getMonth() + 1;
        const year = this.date.getFullYear();
        return String(month).length === 1 ? `0${month}.${year}` : `${month}.${year}`;
    }

    get cardLoading() {
        return this.loading ? 'plywood lighten-1' : null;
    }

    get hasUnsavedChanges() {
        return this.unsavedItems.length > 0;
    }

    @Watch('data', {immediate: true})
    onDataChange(value: Date) {
        this.items = this.getItems();
        this.$nextTick().then(() => {
            let wrapper = this.$el.getElementsByClassName('v-data-table__wrapper')[0];
            if (wrapper) wrapper.scroll(0, 0);
            const thCollection = this.$el.getElementsByTagName('th');
            if (thCollection.length > 0)
                for (let th of thCollection) {
                    if (th.classList.contains('top-side')) th.style.top = `${th.offsetTop}px`;
                    if (th.classList.contains('left-side')) th.style.left = `${th.offsetLeft}px`;
                }
        });
    }

    @Watch('date', {immediate: true})
    onDateChange(value: Date) {
        this.getData();
    }

    beforeRouteLeave(to: Route, from: Route, next: any) {
        if (this.hasUnsavedChanges)
            (this.$refs.confirm as any).open(
                {
                    text: this.$t('Common.Messages.YouHaveUnsavedDataMessage'),
                },
                {
                    callback: () => {
                        next();
                    },
                },
            );
        else next();
    }

    async getData() {
        this.loading = true;
        try {
            const {data} = await this.$http.get(`${this.$api.journals.scheduleEquipmentActivity}/GetAll`, {
                params: {
                    month: this.month,
                    year: this.year,
                },
            });
            this.data = data;
        } finally {
            this.loading = false;
        }
    }

    getItems() {
        const result = [];

        if (!this.data) return null;
        const data = this.data;
        if (data.Dates && data.Dates.length > 0) {
            let tr1 = [],
                tr2 = [];
            tr1.push({
                colspan: 2,
                style: 'border-bottom: none; z-index: 3;',
                class: 'sticky-cell top-side left-side',
            });
            tr2.push({
                colspan: 2,
                style: 'border-top: none; z-index: 3;',
                class: 'sticky-cell top-side left-side',
            });
            data.Dates.forEach((date: any) => {
                tr1.push({
                    colspan: 2,
                    text: date.Name,
                    class: 'text-center sticky-cell top-side',
                });
                date.Schedule.forEach((sch: any) => {
                    tr2.push({
                        text: sch.Name,
                        style: `background: var(--v-plywood-lighten1); color: #fff;`,
                        class: 'text-center sticky-cell top-side',
                    });
                });
            });

            result.push(tr1);
            result.push(tr2);
        }

        data.EquipmentTypes.forEach((equipmentType: any, equipmentTypeIndex: number) => {
            let length = equipmentType.Equipments.length;
            for (let i = 0; i < length; i++) {
                let tr = [];
                if (i === 0)
                    tr.push({
                        rowspan: length,
                        text: equipmentType.Name,
                        class: `text-center align-middle ${data.Dates.length > 0 ? 'sticky-cell left-side' : ''}`,
                    });
                tr.push({
                    text: equipmentType.Equipments[i].Name,
                    style: `background: var(--v-plywood-lighten1); color: #fff;`,
                    class: `align-middle ${data.Dates.length > 0 ? 'sticky-cell left-side' : ''}`,
                });
                if (data.Dates && data.Dates.length > 0) {
                    data.Dates.forEach((date: any) => {
                        date.Schedule.forEach((sch: any) => {
                            let activityCell = data.Items.find(
                                (item: any) =>
                                    item.IdEquipment === equipmentType.Equipments[i].Id &&
                                    item.IdSchedule === sch.Schedule,
                            );
                            if (activityCell)
                                tr.push({
                                    value: activityCell.Activity,
                                    oldValue: activityCell.Activity,
                                    'activity-cell': true,
                                    active: false,
                                    class: 'activity-cell text-right align-middle',
                                    IdEquipment: activityCell.IdEquipment,
                                    IdSchedule: activityCell.IdSchedule,
                                });
                            else
                                tr.push({
                                    value: 100,
                                    oldValue: 100,
                                    'activity-cell': true,
                                    active: false,
                                    class: 'activity-cell text-right align-middle',
                                    IdEquipment: equipmentType.Equipments[i].Id,
                                    IdSchedule: sch.Schedule,
                                });
                        });
                    });
                } else {
                    if (i === 0 && equipmentTypeIndex === 0) {
                        let rowspan = 0;
                        data.EquipmentTypes.forEach((item: any) => {
                            rowspan += item.Equipments.length;
                        });
                        tr.push({
                            rowspan,
                        });
                    }
                }
                result.push(tr);
            }
        });

        return result;
    }

    async save() {
        if (!this.hasUnsavedChanges) return;
        const timerId = setTimeout(() => {
            this.loading = true;
        }, 100);
        try {
            const {data} = await this.$http.post(
                `${this.$api.journals.scheduleEquipmentActivity}/Save`,
                this.serverItems,
                {
                    params: {
                        month: this.month,
                        year: this.year,
                    },
                },
            );
            this.data = data;
            this.unsavedItems = [];
            this.serverItems = [];
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }

    onActivityCellValueChange(value: any, cell: any) {
        cell.value = value;
        let item = this.serverItems.find(
            item => item.IdEquipment === cell.IdEquipment && item.IdSchedule === cell.IdSchedule,
        );
        if (item) item.Activity = value;
        else
            this.serverItems.push({
                IdEquipment: cell.IdEquipment,
                IdSchedule: cell.IdSchedule,
                Activity: value,
            });

        if (value != cell.oldValue) {
            let unsavedItem = this.unsavedItems.find(
                item => item.IdEquipment === cell.IdEquipment && item.IdSchedule === cell.IdSchedule,
            );
            if (!unsavedItem) {
                this.unsavedItems.push(cell);
            }
        } else {
            this.unsavedItems = this.unsavedItems.filter(
                item => item.IdEquipment != cell.IdEquipment || item.IdSchedule != cell.IdSchedule,
            );
        }
    }
    onDatePickerChange(date: string) {
        if (this.hasUnsavedChanges)
            (this.$refs.confirm as any).open(
                {
                    text: this.$t('Common.Messages.YouHaveUnsavedDataMessage'),
                },
                {
                    callback: () => {
                        this.datePickerValue = date;
                        this.unsavedItems = [];
                        this.serverItems = [];
                    },
                },
            );
        else {
            this.datePickerValue = date;
        }
        this.datePicker = false;
    }
}
